import React, { useState } from 'react';
import { FileText } from '@phosphor-icons/react';

const HEADER_TAGS = new Set(['ISA', 'GS', 'ST', 'AK1', 'AK2', 'BHT']);
const ERROR_TAGS = new Set(['IK3', 'IK4', 'IK5', 'AK9']);

const segmentClass = (tag) => {
  if (ERROR_TAGS.has(tag)) return 'text-red-400';
  if (HEADER_TAGS.has(tag)) return 'text-amber-300';
  return 'text-emerald-300';
};

const RawEdiViewer = ({ raw, filename }) => {
  const [open, setOpen] = useState(false);
  if (!raw) return null;
  const segments = raw
    .replace(/\r/g, '')
    .split('~')
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="text-xs text-indigo-600 hover:text-indigo-800 underline-offset-2 hover:underline inline-flex items-center gap-1"
        data-testid="view-raw-edi-toggle"
      >
        <FileText size={12} />
        {open ? 'Hide raw EDI' : `View raw EDI (${segments.length} segments)`}
      </button>
      {open && (
        <div className="mt-2 bg-slate-900 text-emerald-300 font-mono text-[10px] leading-relaxed p-3 rounded border border-slate-700 max-h-96 overflow-y-auto">
          <div className="text-slate-400 text-[9px] mb-2">{filename}</div>
          {segments.map((seg, i) => {
            const tag = seg.split('*')[0];
            return (
              <div key={`seg-${i}`} className={segmentClass(tag)}>
                <span className="text-slate-500 select-none mr-2">
                  {String(i + 1).padStart(3, '0')}
                </span>
                {seg}~
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RawEdiViewer;
